export default "__VITE_ASSET__CM2Tep7Z__"